import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { AppRole } from '@core/enums/rol.enum';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private readonly _http = inject(HttpClient);
  private readonly API_URL = environment.api_url;

  private readonly _rolesSubject = new BehaviorSubject<AppRole[]>([]);
  readonly roles$ = this._rolesSubject.asObservable();

  /**
   * Consulta los roles del usuario en el backend y los mantiene en memoria.
   * Mientras el endpoint no este disponible se devuelve la constante con los roles.
   * Para probar: quita o agrega roles de la lista segun lo necesites.
   */
  loadRoles(): Observable<AppRole[]> {
    // TODO: reemplazar por el endpoint real cuando el backend este listo.
    // return this._http.get<AppRole[]>(`${this.API_URL}/roles`);
    const roles: AppRole[] = [
      AppRole.CONFIGURAR_PERFIL,
      AppRole.CAMBIAR_CLAVE,
      AppRole.SIMULAR_OBJETIVO_AHORRO,
      AppRole.DEFINIR_OBJETIVO_AHORRO,
      AppRole.CONSULTAR_OBJETIVO_AHORRO,
      AppRole.MODIFICAR_OBJETIVO_AHORRO,
      AppRole.CONSULTAR_MOVIMIENTOS_OBJETIVO_AHORRO,
      AppRole.CONSULTAR_BALANCE_AHORROS,
      AppRole.CREAR_METODO_PAGO,
      AppRole.CONSULTAR_METODO_PAGO,
      AppRole.MODIFICAR_METODO_PAGO,
      AppRole.CONSULTAR_ESTADO_CUENTA,
      AppRole.REALIZAR_APORTE_EXTRAORDINARIO,
      AppRole.SOLICITAR_RETIRO,
    ];
    this.setRoles(roles);
    return of(roles);
  }

  get userRoles(): AppRole[] {
    return this._rolesSubject.getValue();
  }

  hasRole(role: AppRole): boolean {
    return this.userRoles.includes(role);
  }

  hasAnyRole(roles: AppRole[]): boolean {
    return roles.some((role) => this.hasRole(role));
  }

  clearRoles(): void {
    this._rolesSubject.next([]);
  }

  private setRoles(roles: AppRole[]): void {
    this._rolesSubject.next(roles);
  }
}
